// The quick-add button's shared state (UX §1 "Quick-add FAB"): which form is open, and the lead the
// member is looking at — an open lead drawer registers itself, so Task, Site visit and Note start
// with that lead filled in. A tiny store instead of a context: the drawer and the button live in
// different branches of the tree.
import { useSyncExternalStore } from 'react';

export type QuickAddKind = 'lead' | 'task' | 'visit' | 'note';

export interface QuickAddLead {
  id: string;
  name: string;
  /** Its pipeline cards, so a visit or task starts in the right project. */
  interests?: { id: string; projectId: string }[];
}

interface State {
  open: QuickAddKind | null;
  lead: QuickAddLead | null;
}

let state: State = { open: null, lead: null };
const listeners = new Set<() => void>();
const set = (next: Partial<State>) => {
  state = { ...state, ...next };
  listeners.forEach((l) => l());
};

export const quickAdd = {
  open: (kind: QuickAddKind) => set({ open: kind }),
  close: () => set({ open: null }),
  /** An open lead drawer calls this with its lead, and with null when it closes. */
  setLead: (lead: QuickAddLead | null) => {
    if (JSON.stringify(state.lead) !== JSON.stringify(lead)) set({ lead });
  },
};

export function useQuickAdd(): State {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
  );
}
